import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-226e1d0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Cookies", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Cookies on Derivitec", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third" }, "Cookies", -1))
const _hoisted_4 = { class: "two-thirds" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cookies are files saved on your phone, tablet or computer when you visit a website.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We use cookies to store information about how you use the Derivitec website, such as the pages you visit.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Cookie settings", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We use 2 types of cookie. You can choose which cookies you're happy for us to use.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Cookies that measure website use", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " We use Google Analytics to measure how you use the website so we can improve it based on user needs. We do not allow Google to use or share the data about how you use this site. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Google Analytics sets cookies that store anonymised information about: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "how you got to the site"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("the pages you visit on "),
      /*#__PURE__*/_createElementVNode("a", { href: "/" }, "derivitec.com"),
      /*#__PURE__*/_createTextVNode(", and how long you spend on each page")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "what you click on while you're visiting the site")
  ])
], -1))
const _hoisted_12 = { class: "cookie-toggle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Strictly necessary cookies", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "These essential cookies do things like remebering your preferences set on this page while using the site.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "They always need to be on.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "columns" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("fieldset", _hoisted_12, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: true,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preference) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.preference]
              ]),
              _createTextVNode(" Use cookies that measure my website use ")
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: false,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.preference) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.preference]
              ]),
              _createTextVNode(" Do not use cookies that measure my website use ")
            ])
          ]),
          _hoisted_13,
          _hoisted_14,
          _hoisted_15
        ])
      ]),
      _: 1
    })
  ]))
}